<div class="modal-header">
  <h4 class="modal-title" id="modal-title" translate>FONTAWESOME_ICONS</h4>
  <button type="button" class="close" aria-describedby="modal-title" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body row">
  <lib-fontawesome-icons [height]="height" (selectedIcon)="selectIcon($event)"></lib-fontawesome-icons>
</div>
<div class="modal-footer">
  <div class="row w-100">
    <div class="col d-flex justify-content-end">
      <button type="button" class="btn btn-light btn-sm" (click)="activeModal.close(false)" translate>CANCEL</button>
    </div>
  </div>
</div>
